import {
    ChangeDetectionStrategy,
    Component,
    Input,
    ViewEncapsulation,
} from '@angular/core';

@Component({
    selector: 'cmps-coaching-focus-label',
    template: ` <div class="cmps-coaching-focus-label--status">
            {{ statusLabel }}
        </div>
        <div class="cmps-coaching-focus-label--behaviour">
            <span>{{ behaviourLabel }}&nbsp;</span>
            <span>{{ behaviour }}</span>
        </div>
        <div
            class="cmps-coaching-focus-label--sub-behaviour"
            *ngIf="subBehaviour"
        >
            <span>{{ subBehaviourLabel }}&nbsp;</span>
            <span>{{ subBehaviour }}</span>
        </div>`,
    host: {
        class: 'cmps-coaching-focus-label',
    },
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class CmpsFocusLabelComponent {
    @Input() statusLabel: string;
    @Input() behaviourLabel: string;
    @Input() behaviour: string;
    @Input() subBehaviourLabel: string;
    @Input() subBehaviour: string;
}
